<template>
  	<!-- <div class="ma-0 container"> -->
    	<v-card style="max-width: fit-content; padding: 10px; padding-right: 0px;" flat color="transparent">
    	<!-- <v-card style="max-width: fit-content; padding: 10px;z-index: 50;" flat color="transparent"> -->
			<v-card-title class="pa-0">
				<v-alert
					v-if="isHolidayToday == true || isHolidayTom == true"
					dense
					width="382px"
					color="rgb(52, 73, 94)"
					class="mb-2"
					border="left"
					elevation="2"
					colored-border
					icon="mdi-information-outline"
					transition="scale-transition"
				>
                    <div style="line-height: 0.7; padding-top: 10px;">
                        <strong v-if="isHolidayToday == true" style="color: red;">本日はHRD休業日となります。<br></strong>
                        <p v-if="isHolidayToday == true" class="caption grey--text ma-0" style="top: 120px;">HRD will be closed today.</p>
                        <br v-if="isHolidayToday && isHolidayTom">
                        <strong v-if="isHolidayTom == true" style="color: red;">明日はHRD休業日となります。<br></strong>
                        <p v-if="isHolidayTom == true" class="caption grey--text ma-0" style="top: 120px;">Tomorrow will be a HRD holiday.</p>
                    </div>
				</v-alert>
			</v-card-title>
			<div class="calendars-container">
				<div class="calendar">
					<v-btn icon style="display: inline-block;"><v-icon large @click="previousMonths">mdi-menu-left</v-icon></v-btn>
    				<span style="display: inline-block;font-size: 1.1rem;">{{ currentYear }} 年 {{ currentMonth }} 月</span>
					<table>
						<thead>
							<tr>
								<th v-for="(day, index) in days" :key="index" :style="{ 'color' : day == '日' ? 'red' : '', 'font-size' : '12px' }">{{ day }}</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(week, weekIndex) in currentCalendar" :key="weekIndex">
								<td
									v-for="(day, dayIndex) in week"
									:key="dayIndex"
									style="text-align:center;font-size: 12px;"
									class="pl-1 pr-1"
									:style="{ 
										'background-color': day.isIncluded ? day.color : '', 
										'cursor' : 'default', 
										'border' : day.isIncluded ? '1px solid black' : '',
										'color': day.dayOfWeek == 1 || day.type == 1 ? 'red' : day.dayOfWeek == 0 || day.type == 2 ? 'blue' : ''
									}"
									>
									<v-tooltip v-if="day.type == 1 || day.type == 2" bottom>
										<template v-slot:activator="{ on, attrs }">
										<div v-bind="attrs" v-on="on">
											{{ day.day }}
										</div>
										</template>
										<div style="line-height:95%">
											<span>{{ day.type == 1 ? holidayKanji : notHolidayKanji }}</span> <br>
											<span v-if="day.type == 2">HRDローカルスタッフは公休 <br></span>
											<span style="font-size: x-small;">{{ day.type == 1 ? holidayEng : notHolidayEng }} <br>
											<span v-if="day.type == 2">HRD local staff are on public holiday.</span> 
											</span>
										</div>
									</v-tooltip>
									<div v-else>
										{{ day.day }}
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="calendar">
					<div style="text-align: end;">
						<span style="display: inline-block;font-size: 1.1rem;">{{ nextMonthYear }} 年 {{ nextMonth }} 月</span>
					<v-btn icon style="display: inline-block;"><v-icon large @click="nextMonths">mdi-menu-right</v-icon></v-btn>
					</div>
					
					<table>
						<thead>
							<tr>
								<th v-for="(day, index) in days" :key="index" :style="{ 'color' : day == '日' ? 'red' : '', 'font-size' : '12px' }">{{ day }}</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(week, weekIndex) in nextCalendar" :key="weekIndex">
								<td
									v-for="(day, dayIndex) in week"
									:key="dayIndex"
									style="text-align:center;font-size: 12px;"
									class="pl-1 pr-1"
									:style="{ 
										'background-color': day.isIncluded ? day.color : '', 
										'cursor' : 'default', 
										'border' : day.isIncluded ? '1px solid black' : '',
										'color': day.dayOfWeek == 1 || day.type == 1 ? 'red' : day.dayOfWeek == 0 || day.type == 2 ? 'blue' : ''
									}"
									>
									<v-tooltip v-if="day.type == 1 || day.type == 2" bottom>
										<template v-slot:activator="{ on, attrs }">
										<div v-bind="attrs" v-on="on">
											{{ day.day }}
										</div>
										</template>
										<div style="line-height:95%">
											<span>{{ day.type == 1 ? holidayKanji : notHolidayKanji }}</span> <br>
											<span v-if="day.type == 2">HRDローカルスタッフは公休 <br></span>
											<span style="font-size: x-small;">{{ day.type == 1 ? holidayEng : notHolidayEng }} <br>
											<span v-if="day.type == 2">HRD local staff are on public holiday.</span> 
											</span>
										</div>
									</v-tooltip>
									<div v-else>
										{{ day.day }}
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div style="font-size: xx-small; margin-left: 100px;">
				<div class="legend-box" style="background-color: #CCFFCC;"></div>{{ holidayKanji }}
				<div class="legend-box" style="background-color: #FCD5B4; margin-left: 10px;"></div>{{ notHolidayKanji }} <br>
				<div style="margin-left: 65px;">HRDローカルスタッフは公休</div>
			</div>
		</v-card>
	<!-- </div> -->
</template>

<script>
import moment from 'moment'
export default {
	data() {
		let currentYear = moment().year()
		let currentMonth = moment().month() + 1
		let nextMonth = 0
		let nextMonthYear = 0
		if (currentMonth + 1 == 13) {
			nextMonth = 1
			nextMonthYear = currentYear + 1
		} else {
			nextMonth = currentMonth + 1 
			nextMonthYear = currentYear
		}
		return {
			currentYear: currentYear,
			currentMonth: currentMonth,
			nextMonthYear: nextMonthYear,
			nextMonth: nextMonth,
			days: ['日', '月', '火', '水', '木', '金', '土'],
			isHolidayToday : false,
            isHolidayTom : false,
			holidays: [],
			holidayKanji: '休み',
			holidayEng: 'Holiday',
			notHolidayKanji: '祝祭日ではありませんが ',
			notHolidayEng: `It's not a public holiday`,
		};
	},

	computed: {
		currentCalendar() {
			return this.generateCalendar(this.currentYear, this.currentMonth)
		},
		nextCalendar() {
			return this.generateCalendar(this.nextMonthYear, this.nextMonth)
		},
	},

  	methods: {

		getHOlidays() {
			this.isHolidayToday = false
			this.isHolidayTom = false
            axios({
                method: "post",
                url: '/api/hrdCalendar/index',
                // data: {
                //     userID : this.loggedInUser.id
                // },
            }).then((res) => {
                this.holidays = res.data
                // console.log(this.holidays)

				let today = new Date()
				let formattedToday = moment(today).format('YYYY-MM-DD')
				let isTodayHoliday = this.holidays.some(holiday => holiday.date == formattedToday);

				if (isTodayHoliday) {
					let todayHoliday = this.holidays.find(holiday => holiday.date == formattedToday);
					// if (todayHoliday.type == '1') { // uncomment this for holiday only
					if (todayHoliday) {
						this.isHolidayToday = true;
					}
				}

				let tom = new Date(today)
				tom.setDate(tom.getDate() + 1)
				let formattedTom = moment(tom).format('YYYY-MM-DD')
				let isTomHoliday = this.holidays.some(holiday => holiday.date == formattedTom);

				if (isTomHoliday) {
					let tomHoliday = this.holidays.find(holiday => holiday.date == formattedTom);
					// if (tomHoliday.type == '1') { // uncomment this for holiday only
					if (tomHoliday) {
						this.isHolidayTom = true;
					}
				}
            })
        },

		generateCalendar(year, month) {
			let firstDay = new Date(year, month - 1, 1).getDay()
			let numberOfDays = new Date(year, month, 0).getDate()
			let calendar = []
			let week = Array.from({ length: firstDay }, () => "")

			for (let i = 1; i <= numberOfDays; i++) {
				let currentDate = new Date(year, month - 1, i+1)
				let isIncluded = this.isDateIncluded(currentDate)
				let dayObject = {
					day: i,
					isIncluded,
					dayOfWeek: currentDate.getDay()
				};

				if (isIncluded) {
					// Get the color and title for the holiday
					let holidayColor = this.getHolidayColor(currentDate)
					// let holidayTitle = this.getHolidayTitle(currentDate)

					dayObject.color = holidayColor
					dayObject.type = holidayColor == '#CCFFCC' ? '1' : '2'
					// dayObject.title = holidayTitle
				}

				week.push(dayObject)

				if ((i + firstDay) % 7 === 0) {
					calendar.push([...week])
					week = []
				}
			}

			if (week.length > 0) {
				calendar.push([...week])
			}

			// console.log(calendar)
			return calendar
		},

		isDateIncluded(date) {
			let formattedDate = date.toISOString().split('T')[0]

			// Check if the date is in the list of holidays
			return this.holidays.some(holiday => holiday.date === formattedDate)
		},

		getHolidayColor(date) {
			let formattedDate = date.toISOString().split('T')[0]

			// Find the color for the corresponding holiday
			let holiday = this.holidays.find(h => h.date === formattedDate)
			return holiday ? holiday.color : ''
		},

		// getHolidayTitle(date) {
		// 	let formattedDate = date.toISOString().split('T')[0]

		// 	// Find the title for the corresponding holiday
		// 	let holiday = this.holidays.find(h => h.date === formattedDate)
		// 	return holiday ? holiday.title : ''
		// },

		previousMonths() {
			this.currentMonth -= 1
			if (this.currentMonth < 1) {
				this.currentYear -= 1
				this.currentMonth = 12 + this.currentMonth
			}

			this.nextMonth -= 1
			if (this.nextMonth < 1) {
				this.nextMonthYear -= 1
				this.nextMonth = 12 + this.nextMonth
			}
		},

		nextMonths() {
			this.currentMonth += 1
			if (this.currentMonth > 12) {
				this.currentYear += 1
				this.currentMonth = this.currentMonth - 12
			}

			this.nextMonth += 1
			if (this.nextMonth > 12) {
				this.nextMonthYear += 1
				this.nextMonth = this.nextMonth - 12
			}
		},
	},

	mounted() {
		this.getHOlidays()
		// console.log(this.currentYear)
		// console.log(this.currentMonth)
		// console.log(this.currentCalendar);
		// console.log(this.nextCalendar);
	},
};
</script>

<style>
.calendars-container {
  display: flex;
  justify-content: space-between;
}

.calendars-container td {
	font-family: "Rubik", sans-serif !important;
}

.calendar {
	margin-left: 5px;
	margin-right: 5px;
}

.controls {
  text-align: center;
}

.legend-box {
	width: 12px; /* Adjust the width as needed */
	height: 12px; /* Adjust the height as needed */
	border: 1px solid;
	margin-right: 5px; /* Adjust the margin as needed */
	display: inline-block;
}

</style>
